module.exports = __webpack_public_path__ + "img/03.5fa493a1.gif";